import React from "react";
import { node } from "prop-types";
import Image from "../Image";
import Link from "../Link";

const ItemTitle = ({ children, ...props }) => (
	<div className="updates-page-template__list-item-title">
		<Link className="updates-page-template__list-item-title-link" {...props}>
			{children}
		</Link>
	</div>
);

ItemTitle.propTypes = {
	children: node.isRequired,
};

const ItemDate = ({ children, ...props }) => (
	<div className="updates-page-template__list-item-date" {...props}>
		{children}
	</div>
);

ItemDate.propTypes = {
	children: node.isRequired,
};

const ItemImage = ({ src, alt = "", ...props }) => (
	<div className="updates-page-template__list-item-image">
		<Image src={src} alt={alt} isBaseUrl={false} {...props} />
	</div>
);

ItemImage.propTypes = {
	...ItemImage.propTypes,
};

const ItemDescription = ({ children }) => (
	<div className="updates-page-template__list-item-description">{children}</div>
);

ItemDescription.propTypes = {
	children: node.isRequired,
};

const ItemAction = ({ children, ...props }) => (
	<div className="updates-page-template__list-item-action">
		<Link className="updates-page-template__list-item-action-link" {...props}>
			{children} ›
		</Link>
	</div>
);

ItemAction.propTypes = {
	children: node.isRequired,
};

const UpdatesPageTemplateListItem = ({ children }) => (
	<div className="updates-page-template__list-item">{children}</div>
);

UpdatesPageTemplateListItem.propTypes = {
	children: node.isRequired,
};

UpdatesPageTemplateListItem.Title = ItemTitle;
UpdatesPageTemplateListItem.Date = ItemDate;
UpdatesPageTemplateListItem.Image = ItemImage;
UpdatesPageTemplateListItem.Description = ItemDescription;
UpdatesPageTemplateListItem.Action = ItemAction;

export default UpdatesPageTemplateListItem;
